import { OrderSettingsEnum } from "Data/settings";

export const SettingTabColumns = {
  [OrderSettingsEnum.SPECIAL_CARE]: {
    columns: [
      "switch",
      "code",
      "version",
      "name",
      "maxWeight",
      "maxDimension",
      "validFrom",
      "validTo",
      "surcharge",
    ],
    subcolumns: ["maxWeight", "maxDimension", "validFrom", "validTo", "surcharge"],
  },
  [OrderSettingsEnum.SPECIAL_CONDITION]: {
    columns: [
      "switch",
      "code",
      "version",
      "name",
      "maxWeight",
      "maxDimension",
      "validFrom",
      "validTo",
      "surcharge",
    ],
    subcolumns: ["maxWeight", "maxDimension", "validFrom", "validTo", "surcharge"],
  },
  [OrderSettingsEnum.SERVICE_TYPE]: {
    columns: ["switch", "code", "version", "name", "validFrom", "validTo", "surcharge"],
    subcolumns: ["surcharge", "validFrom", "validTo"],
  },
  [OrderSettingsEnum.DELIVERY_TYPE]: {
    columns: [
      "switch",
      "code",
      "version",
      "name",
      "serviceTypes",
      "validFrom",
      "validTo",
      "surcharge",
    ],
    subcolumns: ["surcharge", "validFrom", "validTo"],
  },
  [OrderSettingsEnum.LOCATION]: {
    columns: [
      "switch",
      "id",
      "version",
      "areaName",
      "states",
      "postcode",
      "deliveryTypes",
      "validFrom",
      "validTo",
      "surcharge",
    ],
    subcolumns: ["surcharge", "validFrom", "validTo"],
  },
  [OrderSettingsEnum.RATE_TABLE]: {
    columns: [
      "switch",
      "id",
      "version",
      "location",
      "postcode",
      "serviceTypes",
      "deliveryTypes",
      "estimatedDeliveryInDay",
      "estimatedTime",
      "cutOffTime",
      "validFrom",
      "validTo",
    ],
    subcolumns: ["surcharge", "validFrom", "validTo"],
  },
  [OrderSettingsEnum.CUSTOMER_RATE_TABLE]: {
    columns: [
      "switch",
      "id",
      "customerName",
      "version",
      "location",
      "postcode",
      "serviceTypes",
      "deliveryTypes",
      "estimatedDeliveryInDay",
      "estimatedTime",
      "cutOffTime",
      "validFrom",
      "validTo",
    ],
    subcolumns: ["surcharge", "validFrom", "validTo"],
  },
  [OrderSettingsEnum.ISSUE_TYPE]: { columns: ["switch", "code", "name", "remarks", "action"] },
  [OrderSettingsEnum.TYPE_OF_GOODS]: {
    columns: ["switch", "code", "name", "remark", "isProhibited", "action"],
  },
  [OrderSettingsEnum.INSURANCE]: {
    columns: [
      "switch",
      "code",
      "version",
      "valueFrom",
      "valueTo",
      "validFrom",
      "validTo",
      "charge",
    ],
    subcolumns: ["charge", "validFrom", "validTo"],
  },
};
